// extracted by mini-css-extract-plugin
module.exports = {"entityInfoContainer":"_2Umi5JVgL1Y6lbsrhhf_NJ","entityInfoButton":"_3DQW1WtKPv_8aK3QHBOuSo"};